import {
  SectionContainer,
  SectionTitle,
  SectionTitleHeading,
  SectionTitleBody,
  Slider,
  SliderSlide,
  BackgroundColor,
  BlockContentValue,
  isBlockContentValuePresent
} from "@silversea-ssc/ui-components-react";
import CruiseEventCard from "src/page-components/cruise/cruise-events/CruiseEventCard";
import { cardColorForBackground } from "components/PageBuilder/pageBuilderRenderHelper";
import React, { useCallback, useState } from "react";
import { CruiseEventFragment } from "types/graphql-types";
import { BlockContent } from "components/BlockContent";
const CruiseEventModal = React.lazy(() => import("./CruiseEventModal"));

type Props = {
  id: string;
  backgroundColor: BackgroundColor;
  title: string | undefined;
  content: BlockContentValue | undefined;
  events: CruiseEventFragment[];
};

const CruiseEvents: React.FC<Props> = ({
  id,
  backgroundColor,
  title,
  content,
  events
}) => {
  const cardColor = cardColorForBackground(backgroundColor);

  const [openedCruiseEvent, setOpenCruiseEvent] = useState<
    CruiseEventFragment | undefined
  >(undefined);

  return (
    <React.Fragment>
      <SectionContainer
        dataContentName="cruise_events"
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor={backgroundColor}
        id={id}
      >
        <SectionTitle variant="wide">
          <SectionTitleHeading>{title}</SectionTitleHeading>
          {isBlockContentValuePresent(content) && (
            <SectionTitleBody>
              <BlockContent value={content} />
            </SectionTitleBody>
          )}
        </SectionTitle>
        <Slider variantColor="white">
          {events.map((event) => {
            return (
              <CruiseEventSlide
                key={event._key}
                event={event}
                onClick={setOpenCruiseEvent}
                cardColor={cardColor}
              />
            );
          })}
        </Slider>
      </SectionContainer>
      {openedCruiseEvent && (
        <React.Suspense fallback={<div></div>}>
          <CruiseEventModal
            modal={{
              isOpen: !!openedCruiseEvent,
              onRequestClose: () => setOpenCruiseEvent(undefined)
            }}
            event={openedCruiseEvent}
          />
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

type CruiseEventSlideProps = {
  cardColor: BackgroundColor;
  event: CruiseEventFragment;
  onClick: (event: CruiseEventFragment) => void;
};
const CruiseEventSlide: React.FC<CruiseEventSlideProps> = ({
  event,
  onClick,
  cardColor
}) => {
  const _onClick = useCallback(() => {
    onClick(event);
  }, [event, onClick]);

  return (
    <SliderSlide key={event._key}>
      <CruiseEventCard
        cardBackgroundColor={cardColor}
        title={event.title?.localized || ""}
        location={event.location?.localized || ""}
        date={event.date}
        image={event.cardImage}
        onClick={_onClick}
      />
    </SliderSlide>
  );
};

export default CruiseEvents;
